import http from '@utils/http'

/*
* 获取订单列表
**/
export function getOrderList(data): Promise<any> {
    return http.post('/pay/payRecord', data || {})
}
/* 
* 查询订单详情
*/
export function getOrderDetail(data): Promise<any> {
    return http.post('/pay/orderDetail', data || {})
}